import React from 'react';
import QnAList from '../components/setting/QnAList';

const QnAListPage: React.FC = () => {
  return (
    <div className="main-container">
      <QnAList />
    </div>
  );
};

export default QnAListPage;
